import React from 'react';
import { FlashcardProvider } from './context/FlashcardContext/index';
import { ThemeProvider } from './context/ThemeContext';
import ReviewScreen from './components/ReviewScreen';
import InstallPWA from './components/InstallPWA';
import { SpeedInsights } from "@vercel/speed-insights/react";

export default function App() {
  document.title = "QuickStudy";
  return (
    <ThemeProvider>
      <meta name="viewport" content="width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no" />
      <FlashcardProvider>
        <ReviewScreen />
        <InstallPWA />
        <SpeedInsights />
      </FlashcardProvider>
    </ThemeProvider>
  );
}
